export class Datalayer extends Array {
    callbacks = [];

    registerCallback(cb) {
        this.callbacks.push(cb);
    }

    push(...items) {
        items.forEach(item => {
            this.callbacks.forEach(cb => cb(item));
        })
        super.push(items);
    }

    startSyncDatalayerGTM() {
        function sync(callbacks, currentPos) {
            const currentSize = window.dataLayer.length;
            if (window.dataLayer instanceof Array) {
                const elementsToProcess = window.dataLayer.slice(currentPos, currentSize);
                elementsToProcess.forEach(item => {
                    callbacks.forEach(cb => cb(item));
                })
            }
            setTimeout(sync, 500, callbacks, currentSize)
        }

        sync(this.callbacks, 0);
    }
}